import React from 'react';
export const Header = () => {
  return <header className="w-full bg-gray-900 text-white py-2" data-id="element-190">
      <div className="max-w-6xl mx-auto flex justify-between items-center px-4" data-id="element-191">
        <div className="flex-1" data-id="element-192"></div>
        <div className="text-center flex-1 font-semibold text-lg" data-id="element-193">
          WOMEN'S HEALTH
        </div>
        <div className="flex-1 flex justify-end items-center" data-id="element-194">
          <div className="flex items-center" data-id="element-195">
            <div className="w-5 h-5 rounded-full overflow-hidden mr-2 flex items-center justify-center" data-id="element-196">
              <span className="text-lg" role="img" aria-label="USA flag" data-id="element-197">
                🇺🇸
              </span>
            </div>
            <span className="text-xs font-medium" data-id="element-198">Trending in the US</span>
          </div>
        </div>
      </div>
    </header>;
};